import GoogleDocIcon from './component.jsx'
export default GoogleDocIcon
